/** Display helpers for received studies. */
export const MATCH_STATUS = {
  matched: { label: 'Matched', tone: 'active' },
  possible_match: { label: 'Possible match', tone: 'pending' },
  unmatched: { label: 'Unmatched', tone: 'failed' },
};

/** DICOM PN "FAMILY^GIVEN^MIDDLE" → "Given Middle Family". */
export const formatPersonName = (value) => {
  if (!value) return '';
  const [family = '', given = '', middle = ''] = String(value).split('^');
  return [given, middle, family].filter(Boolean).join(' ').trim() || value;
};

/** DICOM DA "YYYYMMDD" (+ optional TM "HHMMSS") → readable text. */
export const formatDicomDate = (date, time) => {
  if (!date || !/^\d{8}$/.test(date)) return date || '';
  const text = `${date.slice(0, 4)}-${date.slice(4, 6)}-${date.slice(6, 8)}`;
  // Older rows may have lost the leading zero ("93000" for 09:30:00).
  const padded = time && /^\d{5,6}/.test(time) ? String(time).split('.')[0].padStart(6, '0') : time;
  if (padded && /^\d{4}/.test(padded)) return `${text} ${padded.slice(0, 2)}:${padded.slice(2, 4)}`;
  return text;
};
